interface PercentageChangeRange {
  minValue?: number; // undefined = no lower bound
  maxValue?: number; // undefined = no upper bound
  color: string;
}

export const mileageRanges: PercentageChangeRange[] = [
  { maxValue: -40, color: "var(--mileage-dark-red)" },
  { minValue: -40, maxValue: -30, color: "var(--mileage-medium-red)" },
  { minValue: -30, maxValue: -20, color: "var(--mileage-light-red)" },
  { minValue: -20, maxValue: -10, color: "var(--mileage-dark-orange)" },
  { minValue: -10, maxValue: 0, color: "var(--mileage-medium-orange)" },
  { minValue: 0, maxValue: 10, color: "var(--mileage-light-orange)" },
  { minValue: 10, maxValue: 20, color: "var(--mileage-yellow)" },
  { minValue: 20, maxValue: 30, color: "var(--mileage-green1)" },
  { minValue: 30, maxValue: 40, color: "var(--mileage-green2)" },
  { minValue: 40, maxValue: 50, color: "var(--mileage-green3)" },
  { minValue: 50, maxValue: 60, color: "var(--mileage-green4)" },
  { minValue: 60, maxValue: 70, color: "var(--mileage-green5)" },
  { minValue: 70, color: "var(--mileage-green6)" },
];

export const getMileageCssVar = (value: number): string => {
  for (const range of mileageRanges) {
    const minOk = range.minValue === undefined || value >= range.minValue;
    const maxOk = range.maxValue === undefined || value < range.maxValue;

    if (minOk && maxOk) {
      return range.color;
    }
  }

  // fallback (should never happen if ranges cover all values)
  return "var(--mileage-green6)";
};
